import { auth, userService } from '../../../services';
import { push } from 'react-router-redux';
import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
const warningColor = 'warning';
const successColor = "success";
const errorColor = "danger";

export const SET_USER_ID = 'SET_USER_ID';
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS';
export const UPDATE_ORGANIZATION_ERROR = 'UPDATE_ORGANIZATION_ERROR';
export const UPDATE_ORGANIZATION_REQUEST = 'UPDATE_ORGANIZATION_REQUEST';
export const LEAVE_ORGANIZATION_SUCCESS = 'LEAVE_ORGANIZATION_SUCCESS';
export const LEAVE_ORGANIZATION_ERROR = 'LEAVE_ORGANIZATION_ERROR';
export const LEAVE_ORGANIZATION_REQUEST = 'LEAVE_ORGANIZATION_REQUEST';
export const DELETE_ORGANIZATION_SUCCESS = 'DELETE_ORGANIZATION_SUCCESS';
export const DELETE_ORGANIZATION_ERROR = 'DELETE_ORGANIZATION_ERROR';
export const DELETE_ORGANIZATION_REQUEST = 'DELETE_ORGANIZATION_REQUEST';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';
export const INVITE_USER_ERROR = 'INVITE_USER_ERROR';
export const INVITE_USER_REQUEST = 'INVITE_USER_REQUEST';
export const INVITE_NEW_USER_SUCCESS = 'INVITE_NEW_USER_SUCCESS';
export const INVITE_NEW_USER_ERROR = 'INVITE_NEW_USER_ERROR';
export const INVITE_NEW_USER_REQUEST = 'INVITE_NEW_USER_REQUEST';
export const REMOVE_USER_SUCCESS = 'REMOVE_USER_SUCCESS';
export const REMOVE_USER_ERROR = 'REMOVE_USER_ERROR';
export const REMOVE_USER_REQUEST = 'REMOVE_USER_REQUEST';
export const REINVITE_USER_SUCCESS = 'REINVITE_USER_SUCCESS';
export const REINVITE_USER_ERROR = 'REINVITE_USER_ERROR';
export const REINVITE_USER_REQUEST = 'REINVITE_USER_REQUEST';
export const GET_USER_ORGANIZATIONS_REQUEST = 'GET_USER_ORGANIZATIONS_REQUEST';
export const GET_USER_ORGANIZATIONS_SUCCESS = 'GET_USER_ORGANIZATIONS_SUCCESS';

export function setOrganizationUserId(userId) {
  return function (dispatch) {
    dispatch({
      type: SET_USER_ID,
      payload: userId
    })

    dispatch(push('/my-organization'))
  }
}

export const updateOrganization = (details) => {
	return (dispatch) => {
		dispatch({
			type: UPDATE_ORGANIZATION_REQUEST,
			payload: details
		});
		var url = `${ROOT_API_URL}/organizations/updateorganization`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, details, options).then((res) => {
			if (res && res.data && res.data.isSuccess) {
				dispatch({
					type: UPDATE_ORGANIZATION_SUCCESS,
					payload: res.data
				});
			} else {
				dispatch({
					type: UPDATE_ORGANIZATION_ERROR,
					payload: res.data.message
				});
			}
		});
	};
};

export const leaveOrganization = (details) => {
	return (dispatch) => {
		dispatch({
			type: LEAVE_ORGANIZATION_REQUEST,
			payload: details
		});
		var url = `${ROOT_API_URL}/organizations/leaveorganization`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, details, options).then((res) => {
			if (res && res.data && res.data.isSuccess) {
				dispatch({
					type: LEAVE_ORGANIZATION_SUCCESS,
					payload: res.data
				});
			} else {
				dispatch({
					type: LEAVE_ORGANIZATION_ERROR,
					payload: res.data.message
				});
			}
            dispatch(push('/dashboard'));
		});
	};
};

export const deleteOrganization = (details) => {
  return (dispatch) => {
		dispatch({
			type: DELETE_ORGANIZATION_REQUEST,
			payload: details
		});
		var url = `${ROOT_API_URL}/organizations/deleteorganization`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, details, options).then((res) => {
			if (res && res.data && res.data.isSuccess) {
				dispatch({
					type: DELETE_ORGANIZATION_SUCCESS,
					payload: details
				});
			} else {
				dispatch({
					type: DELETE_ORGANIZATION_ERROR,
					payload: res.data.message
				});
			}
			dispatch(push('/dashboard'));
		});
	};
};

export const getUserOrganizations = (id) => {
	return (dispatch) => {
		dispatch({
			type: GET_USER_ORGANIZATIONS_REQUEST,
			payload: id
		});
		var url = `${ROOT_API_URL}/organizations/getuserorganizations?organizationId=${id}`;
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((response) => {
				dispatch({
					type: GET_USER_ORGANIZATIONS_SUCCESS,
					payload: response.data
				});
			})
			.catch((err) => console.log(err));
	};
};

export const inviteUser = (details) => {
	console.log('inviteUser', details);
  return (dispatch) => {
		dispatch({
			type: INVITE_USER_REQUEST,
			payload: details
		});
		var url = `${ROOT_API_URL}/organizations/inviteuser`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, details, options).then((res) => {
			if (res && res.data && res.data.isSuccess) {
				dispatch({
					type: INVITE_USER_SUCCESS,
					payload: details
				});
			} else {
				dispatch({
					type: INVITE_USER_ERROR,
					payload: res.data.message
				});
			}
		});
	};
};

export const inviteNewUser = (details) => {
	console.log('inviteNewUser', details);
  return (dispatch) => {
		dispatch({
			type: INVITE_NEW_USER_REQUEST,
			payload: details
		});
		var url = `${ROOT_API_URL}/organizations/invitenewuser`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, details, options).then((res) => {
			if (res && res.data && res.data.isSuccess) {
				dispatch({
					type: INVITE_NEW_USER_SUCCESS,
					payload: details
				});
			} else {
				dispatch({
					type: INVITE_NEW_USER_ERROR,
					payload: res.data.message
				});
			}
		});
	};
};

export const removeUser = (details) => {
  return (dispatch) => {
		dispatch({
			type: REMOVE_USER_REQUEST,
			payload: details
		});
		var url = `${ROOT_API_URL}/organizations/removeuser`;
		const options = { method: 'POST', headers: auth.authHeader() };
		axios.post(url, details, options).then((res) => {
			if (res && res.data && res.data.isSuccess) {
				dispatch({
					type: REMOVE_USER_SUCCESS,
					payload: details
				});
				// Call Update Users table - getUserOrganizations
			} else {
				dispatch({
					type: REMOVE_USER_ERROR,
					payload: res.data.message
				});
			}
		});
	};
};

export const reinviteUser = (details) => {
  return (dispatch) => {
		dispatch({
			type: REINVITE_USER_REQUEST,
			payload: details
		});
		var url = `${ROOT_API_URL}/organizations/reinviteuser`;
		const options = { method: 'POST', headers: auth.authHeader() };
		  axios.post(url, details, options)
			  .then((res) => {
				if (res && res.data && res.data.isSuccess) {
					dispatch({
						type: REINVITE_USER_SUCCESS,
						message: res.data.message
					});
					var success = res && res.data ? res.data.message : 'User Invitation Sent Successfully.';
					dispatch(toastr(true, success, successColor));
				} else {
					dispatch({
						type: REINVITE_USER_ERROR,
						message: res.data.message
					});
					var warning = res && res.data ? res.data.message : 'Cannot re-invite and user multiple times in 1 Day.';
					dispatch(toastr(true, warning, warningColor));
				}
			})
		  .catch((err) => console.log(err));

	};
};
